import "./_textarea-field.scss";
import React, {ChangeEvent, useEffect, useState} from 'react';
import {RedAsterisk} from "../../../../components";
import {isValid} from "../../../validation/ValidationUtils";
import {saveSelector} from "../../../slices/NavigationSlice";
import {useAppSelector} from "../../../../store/hooks";
import {kebabCase} from "../../../../utils/stringUtils";

interface TextAreaFieldProps {
    input: string | undefined | null;
    label: string;
    onChange: (input: string) => void;
    subText?: string;
    required?: boolean;
    dataTestId?: string;
}

function TextAreaField({
                           input,
                           label,
                           onChange,
                           subText,
                           required = false,
                           dataTestId = kebabCase(label) + "-field",
                       }: Readonly<TextAreaFieldProps>) {

    const saveHasBeenClicked = useAppSelector(saveSelector);
    const [value, setValue] = useState<string>(input ?? "");
    const [hasError, setHasError] = useState<boolean>(false);
    const [errorText, setErrorText] = useState<string>("");

    const textareaLength = (text: string | undefined | null) => {
        return text ? text.length : 0;
    }

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setValue(event.target.value);
    }

    const isValueRequiredAndInValid = () => {
        const hasValidationError = required && saveHasBeenClicked && !isValid(value);
        setHasError(hasValidationError);
        if (!isValid(value)) {
            setErrorText(`${label} is required.`)
        }
        return hasValidationError
    }

    useEffect(() => {
        setValue(input ?? "");
    }, [input])

    useEffect(() => {
        if (!saveHasBeenClicked) return;
        if (!required) return;
        isValueRequiredAndInValid();
    }, [saveHasBeenClicked, required, value]);

    return (
        <div className="layout-data-entry-form__field textarea-field">
            <div className={`textarea-label ${label}-label`}>
                <label className={"h5"}>
                    {label}
                    {required && <RedAsterisk/>}
                </label>
                <span className='textarea-limit-count'>{textareaLength(value)}/500</span>
            </div>
            <textarea
                name={label}
                aria-label={label}
                className={hasError ? "textarea-box input-skin error" : "textarea-box input-skin"}
                data-testid={dataTestId}
                autoFocus={false}
                rows={5}
                cols={50}
                maxLength={500}
                value={value}
                onChange={handleChange}
                onBlur={(e) => {
                    onChange(e.target.value);
                    isValueRequiredAndInValid();
                }}
            />
            {
                hasError ? <div className='input__info color-text--error'>{errorText}</div> : undefined
            }
            <span className="textarea-sub-text input__info margintop-sm">
                {subText}
            </span>
        </div>
    );
}

export default TextAreaField;